<formulario-dinamico
    #formulario
    [colunas]="filterConfiguration.colunas"
    [(entidade)]="filtro"
    (entidadeChange)="changefiltro($event)"
></formulario-dinamico>